export const FALLBACK_IMPORT_PROFILES = [
  {
    key: "generic_csv",
    label: "Generic CSV",
    description: "Algemene CSV import voor standaard exports.",
    delimiterPreference: ",",
    defaultColumnAliases: {
      bedrijfsnaam: ["bedrijfsnaam", "naam", "company", "companyname"],
      klantnummer: ["klantnummer", "customer_number", "customernumber", "nummer"],
      status: ["status", "state"],
      bezoekadres: ["bezoekadres", "adres", "address", "visitaddress"],
      factuuradres: ["factuuradres", "invoiceaddress", "billingaddress"],
      kvk: ["kvk", "kvknummer", "chamberofcommerce"],
      btw: ["btw", "btwnummer", "vat", "vatnumber"],
      hoofdcontactpersoon: ["hoofdcontactpersoon", "contactpersoon", "primarycontact", "contact"],
      telefoon: ["telefoon", "phone", "mobile"],
      email: ["email", "e-mail", "mail"],
      klanttype: ["klanttype", "customertype", "type"],
    },
  },
  {
    key: "moneybird_contacts",
    label: "Moneybird Contacten",
    description: "CSV exportprofiel uit Moneybird contacten.",
    delimiterPreference: ";",
    defaultColumnAliases: {
      bedrijfsnaam: ["company_name", "company", "bedrijfsnaam", "naam"],
      klantnummer: ["customer_id", "contact_id", "klantnummer"],
      status: ["status"],
      bezoekadres: ["address1", "address", "bezoekadres"],
      factuuradres: ["billing_address", "invoice_address", "factuuradres"],
      kvk: ["coc_number", "kvk", "kvknummer"],
      btw: ["vat_number", "btw", "btwnummer"],
      hoofdcontactpersoon: ["contact_name", "attn", "hoofdcontactpersoon"],
      telefoon: ["phone", "telefoon"],
      email: ["email", "emailaddress"],
      klanttype: ["customer_type", "klanttype"],
    },
  },
  {
    key: "excel_manual",
    label: "Excel Handmatig",
    description: "Handmatig opgebouwde lijst uit Excel (CSV save-as).",
    delimiterPreference: ";",
    defaultColumnAliases: {
      bedrijfsnaam: ["bedrijfsnaam", "naam", "organisatie"],
      klantnummer: ["klantnummer", "relatienummer", "nummer"],
      status: ["status", "actief"],
      bezoekadres: ["bezoekadres", "adres", "adres bezoek"],
      factuuradres: ["factuuradres", "factuur adres"],
      kvk: ["kvk", "kvk nummer", "kvknummer"],
      btw: ["btw", "btw nummer", "btwnummer"],
      hoofdcontactpersoon: ["hoofdcontactpersoon", "contact", "contactpersoon"],
      telefoon: ["telefoon", "tel", "phone"],
      email: ["email", "mail", "e-mail"],
      klanttype: ["klanttype", "type"],
    },
  },
];

export function getProfileByKey(profiles, key) {
  return (profiles || []).find((item) => item.key === key) || FALLBACK_IMPORT_PROFILES[0];
}
